<template>

  <div class="modal fade" id="AddTypeEmplacementModal" tabindex="-1" role="dialog" ref="addTypeEmplacementModalRef"
    aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="TypeEmplacement">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="typeEmplacementForm" @submit="addTypeEmplacement" :validation-schema="typeEmplacementSchema">
            <div class="row">
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Code <span class="text-danger">*</span>
                  </label>
                  <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le code" />
                  <ErrorMessage name="code" class="text-danger" />
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Libelle <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libelle" />
                  <ErrorMessage name="libelle" class="text-danger" />
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Montant <span class="text-danger">*</span>
                  </label>
                  <Field name="montant" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le montant" />
                  <ErrorMessage name="montant" class="text-danger" />
                </div>
              </div>
              <button class="btn btn-primary" type="submit">
                {{ btntext }}
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, hideModal, success } from '@/utils/utils';
import { TypeEmplacement } from '@/models/TypeEmplacement';
import { useRouter } from 'vue-router';

export default {
  name: "AddTypeEmplacementModal",
  components: {
    Form,
    Field,
    ErrorMessage
  },
  props: {
    id: {
      type: Number,
      required: true,
      default: 0
    },
  },
  emits: ["refreshTypeEmplacements", 'openmodal'],
  setup: (props: any, { emit }: { emit: (event: string, payload?: any) => void }) => {
    const loading = ref<boolean>(false);
    const typeEmplacementSchema = Yup.object().shape({
      libelle: Yup.string().required('Le libelle est obligatoire'),
      code: Yup.string().required('Le code est obligatoire'),
      montant: Yup.number().required('Le montant est obligatoire'),

    });
    const typeEmplacementnew = ref(props.id);
    const typeEmplacementForm = ref<TypeEmplacement | null>(null);
    const addTypeEmplacementModalRef = ref<null | HTMLElement>(null);
    let typeEmplacements = ref<Array<TypeEmplacement>>([]);
    const title = ref('Ajouter un type ');
    const btntext = ref('Ajouter');
    const isupdate = ref(false);
    const router = useRouter();
    watch(() => props.id, (newValue) => {
      if (newValue != 0) {
        getTypeEmplacement(newValue);
        isupdate.value = true;
      }
      btnTitle();
    });
    const getTypeEmplacement = async (id: number) => {
      return ApiService.get("/types/" + id)
        .then(({ data }) => {
          typeEmplacementForm.value?.setFieldValue("id", data.data.id);
          typeEmplacementForm.value?.setFieldValue("libelle", data.data.libelle);
          typeEmplacementForm.value?.setFieldValue("code", data.data.code);
          emit('openmodal', addTypeEmplacementModalRef.value);
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }
    const btnTitle = async () => {
      if (isupdate.value) {
        title.value = "Modifier le type emplacement";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter un type emplacement ";
        btntext.value = "Ajouter";
      }
    }
    const addTypeEmplacement = async (values: any, { resetForm }: { resetForm: () => void }) => {
      values = values as TypeEmplacement;
      loading.value = false;
      if (isupdate.value) {
        ApiService.put(`/types/${values.id}`, values)
          .then(({ data }) => {
            if (data.code == 200) {
              success(data.message);
              resetForm();
              hideModal(addTypeEmplacementModalRef.value);
              isupdate.value = false;
              btnTitle();
              emit("refreshTypeEmplacements");
              router.push('/liste-type-emplacement');
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
      } else {
        ApiService.post("/types", values)
          .then(({ data }) => {
            if (data.code == 201) {
              success(data.message)
              resetForm();
              hideModal(addTypeEmplacementModalRef.value);
              emit("refreshTypeEmplacements");
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
      }
    };
    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isupdate.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };
    return {
      typeEmplacements, title, btntext, resetValue, typeEmplacementSchema,
      addTypeEmplacement, typeEmplacementForm, addTypeEmplacementModalRef, typeEmplacementnew,
      //refreshReligions
    };
  },
};
</script>@/models/TypeEmplacement